import { fetchConToken } from "../helpers/fetch";

const ContratacionesReportesService = {
  //REPORTES RED
  traerContratosRed: () => {
    return fetchConToken(`ReportesContratos/Redes`);
  },
  generarExcelContratosRed: () => {
    return fetchConToken(`ReportesContratos/Redes/GenerarExcel`);
  },
  generarPdfContratosRed: () => {
    return fetchConToken(`ReportesContratos/Redes/GenerarPDF`);
  },  

  //NOMENCLADOR
  generateExcelNomenclador: () => {
    return fetchConToken(`ReportesContratos/Nomenclador/GenerarExcel`);
  },
  generatePDFNomenclador: () => {
    return fetchConToken(`ReportesContratos/Nomenclador/GenerarPDF`);
  },

  //REPORTES PRESTADOR
  traerPrestadorReporte: (idTipoEfector, idSubTipoEfector, idProvincia, idLocalidad, idRanking, inactivos) => {
    return fetchConToken(`ReportesContratos/Prestadores?idTipoEfector=${idTipoEfector}&idSubTipoEfector=${idSubTipoEfector}&idProvincia=${idProvincia}&idLocalidad=${idLocalidad}&idRanking=${idRanking}&inactivos=${inactivos}`
    );
  },
  getExcelPrestadores: (idTipoEfector, idSubTipoEfector, idProvincia, idLocalidad, idRanking, inactivos) => {
    return fetchConToken(`ReportesContratos/Prestadores/GenerarExcel?idTipoEfector=${idTipoEfector}&idSubTipoEfector=${idSubTipoEfector}&idProvincia=${idProvincia}&idLocalidad=${idLocalidad}&idRanking=${idRanking}&inactivos=${inactivos}`);
  },
  getPDFPrestadores: (idTipoEfector, idSubTipoEfector, idProvincia, idLocalidad, idRanking, inactivos) => {
    return fetchConToken(`ReportesContratos/Prestadores/GenerarPDF?idTipoEfector=${idTipoEfector}&idSubTipoEfector=${idSubTipoEfector}&idProvincia=${idProvincia}&idLocalidad=${idLocalidad}&idRanking=${idRanking}&inactivos=${inactivos}`);
  },

  //REPORTES PRESTADORES POR PRACTICAS
  traerPracticaReporte: (parametroBusqueda, idLocalidad, idProvincia) => {
    return fetchConToken(`ReportesContratos/PrestadoresPorPractica?parametroBusqueda=${parametroBusqueda.codNom}&idProvincia=${idProvincia}&idLocalidad=${idLocalidad}`
    );
  },
  getExcelPracticaXConvenio: (parametroBusqueda, idLocalidad, idProvincia) => {
    return fetchConToken(`ReportesContratos/PrestadoresPorPractica/GenerarExcel?parametroBusqueda=${parametroBusqueda.codNom}&idProvincia=${idProvincia}&idLocalidad=${idLocalidad}`
    );
  },
  getPDFPracticaXConvenio: (parametroBusqueda, idLocalidad, idProvincia) => {
    return fetchConToken(`ReportesContratos/PrestadoresPorPractica/GenerarPDF?parametroBusqueda=${parametroBusqueda.codNom}&idProvincia=${idProvincia}&idLocalidad=${idLocalidad}`);
  }

}
export { ContratacionesReportesService as default };
